<template>
  <div style="margin-top: 90px;">
    <Nav />
    <Banner />
    <Fix />
    <div class="container">
<!--      <el-breadcrumb separator="/" class="top">-->
<!--        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item>当前</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
      <!-- 新增的产品卡片轮播图组件 -->
      <ProductCarousel />
      <!-- 为您提供更多资讯和服务 -->
      <el-card class="top" v-if="footerData && footerData.serviceArray">
        <div class="introduce">
          <h1 class="center">{{ homeTitle }}</h1><br/>
          <div class="center" v-html="homeDescription"></div>
        </div>
        <div class="info-services">
          <div class="service" v-for="(item, i) in footerData.serviceArray" :key="i"
               @click="navigateTo(item.url)">
            <img src="@/assets/images/icon.png" :alt="item.name" class="service-icon"/>
            <h3>{{ item.name }}</h3>
          </div>
        </div>
      </el-card>
      <!-- 新增自动滚动模块 -->
      <el-card class="top" v-if="certificates && certificates.length">
        <h1 class="center">资质证书</h1><br/>
<!--        <div class="scrolling-container">-->
<!--          <div class="scrolling-content" v-for="certificate in certificates" :key="certificate.id">-->
<!--            <img :src="certificate.imageUrl" :alt="certificate.name" class="certificate-image" />-->
<!--            <h3>{{ certificate.name }}</h3>-->
<!--          </div>-->
<!--        </div>-->
        <StackCarousel
            :items="certificates"
            :interval="4000"
            :autoplay="true"
            :show-arrows="false"
            :show-indicators="true"
            @slide-click="handleSlideClick"
        />
        <div>
        </div>
      </el-card>
    </div>
    <Footer />
  </div>
</template>

<script>
import Banner from './components/Banner'
import ProductCarousel from './components/ProductCarousel' // 引入新组件
import { getAllCertificates } from '@/api'
import {navArray} from "@/config";
import Fix from "./components/Fixed.vue";
import StackCarousel from "@/views/front/components/StackCarousel.vue";
export default {
  name: 'Home',
  components: {
    StackCarousel,
    Fix,
    Banner, // 轮播图
    ProductCarousel, // 横向产品
  },
  props: {},
  watch: {},
  data() {
    return {
      homeTitle: '',
      homeDescription: '',
      certificates: [], // 存储证书数据
      footerData: null,
      // carouselItems: [
      //   {
      //     id: 1,
      //     src: 'https://picsum.photos/800/500?random=1',
      //     alt: '图片1',
      //     title: '标题1',
      //     desc: '这是第一张图片的描述'
      //   },
      //   {
      //     id: 2,
      //     src: 'https://picsum.photos/800/500?random=2',
      //     alt: '图片2',
      //     title: '标题2',
      //     desc: '这是第二张图片的描述'
      //   },
      //   {
      //     id: 3,
      //     src: 'https://picsum.photos/800/500?random=3',
      //     alt: '图片3',
      //     title: '标题3',
      //     desc: '这是第三张图片的描述'
      //   },
      //   {
      //     id: 4,
      //     src: 'https://picsum.photos/800/500?random=4',
      //     alt: '图片4',
      //     title: '标题4',
      //     desc: '这是第四张图片的描述'
      //   }
      // ]
    };
  },
  mounted() {
    this.fetchCertificates();
  },
  created() {
  },
  methods: {
    navigateTo(url) {
      if(url.startsWith("http")){
        window.open(url);
        return;
      }
      this.$router.push(url);
    },
    async fetchCertificates() {
      try {
        const response = await getAllCertificates();
        this.certificates = response.data;
      } catch (error) {
        console.error('Failed to fetch certificates:', error);
      }
    },
    refreshHomeData() {
      try {
        const cachedFooterData = localStorage.getItem('footerData');
        if (cachedFooterData) {
          this.$nextTick(() => {
            this.footerData = JSON.parse(cachedFooterData);
            this.homeTitle = this.footerData.homeTitle || '';
            this.homeDescription = this.footerData.homeDescription || '';

            this.footerData.serviceArray = this.footerData.serviceArray || [];
            let length = this.footerData.serviceArray.length;
            let limit = 4;
            if(length < limit){
              for(let i in navArray) {
                if(Number(i) === 0) continue;
                if(this.footerData.serviceArray.length >= limit){
                  break;
                }
                this.footerData.serviceArray.push({
                  name: navArray[i].name,
                  url: navArray[i].path
                });
              }
            }
          });
        }
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    handleSlideClick(item) {
      // console.log('点击了幻灯片:', item)
      // 可以在这里处理点击事件，比如跳转页面等
    }
  },
};
</script>

<style lang="scss" scoped>
.introduce {
  margin: 20px 0;
  text-align: center;
}

.center {
  text-align: center;
}

/* 新增样式 */
.info-services {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 20px 0;

  .service {
    width: 200px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.05);
    }

    .service-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }
}

//.full-image {
//  width: 100%;
//  height: 100%;
//  object-fit: cover; // 保持图片的宽高比并裁剪以填充容器
//}
//
//.scrolling-container {
//  overflow: hidden;
//  white-space: nowrap;
//  width: 100%;
//  position: relative;
//}
//
//.scrolling-content {
//  display: inline-block;
//  animation: scroll 20s linear infinite;
//  text-align: center;
//  margin: 0 10px;
//}
//
//.certificate-image {
//  width: 80%;
//  max-height: 500px;
//  object-fit: cover;
//  display: block;
//  margin: 0 auto;
//  pointer-events: none;
//}

//@keyframes scroll {
//  100% {
//    transform: translateX(-100%);
//  }
//  0% {
//    transform: translateX(100%);
//  }
//}
//
//.qr-code-container {
//  display: flex;
//  flex-direction: column;
//  align-items: center;
//  justify-content: center;
//
//  p {
//    margin-top: 10px;
//    font-size: 14px;
//    color: #666;
//  }
//}

@media (max-width: 768px) {
  .page {
    padding: 10px;
    margin-top: 60px; // 在移动设备上调整这个值
  }

  .info-services {
    flex-wrap: unset;
  }
}

@media (max-width: 480px) {
  .page {
    padding: 5px;
  }

  .info-services {
    flex-wrap: unset;
  }
}
</style>
